import Lottie from "lottie-react";
import PTSearchAnimation from "./pt-search-animation.json";

function LocationServiceAnimation() {
    return (
        <div id="location-service-animation">
                    <Lottie
                        id="lsa-icon-animation"
                        animationData={PTSearchAnimation}
                        loop={true}
                    />

                    <h4>Checking for Physical Therapists...</h4>
        </div>
    );
}

export default LocationServiceAnimation;